import React, { PureComponent } from 'react';

import { Route, Redirect, Switch } from 'react-router-dom';

import * as Secured from 'secured/containers';
import * as Companies from 'companies/containers';
import * as Subcompanies from 'subcompanies/containers';
import * as Reports from 'reports/containers';
import * as Employees from 'employees/containers';
import * as CustomFieldsEmployees from '../modules/custom_fields_employees/containers';
// import * as Maintenance from "../modules/maintenance";
import Dashboard from 'containers/dashboard/DashboardContainer';
import * as Users from 'users/containers';
import * as Roles from 'roles/containers';
import * as Groups from 'groups/containers';
import * as Import from 'import/containers';
import * as FixedAssets from 'fixedassets/containers';
import * as NotificationsConfig from 'notifications_config/containers';
import * as NotificationsHistoric from 'notifications_historic/containers';
import * as Accounts from 'accounts/containers';
import * as Subaccounts from 'subaccounts/containers';
import * as Depreciations from 'depreciations/containers';
import * as Catalogs from 'catalogs/containers';
import * as CostCenters from 'cost_centers/containers';
import * as Inpc from 'inpc/containers';
import * as Exchange from 'exchange/containers';
import * as Locations from 'locations/containers';
import * as AssetLevel from 'asset_level/containers';
import * as Projects from 'projects/containers';
import * as Providers from 'providers/containers';

import AssetsList from 'containers/assets/AssetsListContainer';
import AssetsAdd from 'containers/assets/AssetsAddContainer';
import AssetsEdit from 'containers/assets/AssetsEditContainer';
import AssetsDisable from 'containers/assets/AssetsDisableContainer';

import ReportsDepreciation from 'containers/reports/ReportsDepreciationContainer';

import { withCompanySelected, withSubcompanySelected, withTokenVerified } from 'secured/hocs';

class SecuredRoutes extends PureComponent {
  render = () => {
    const url = this.props.match.url.replace(/\/$/, '');
    return (
      <Secured.Layout>
        <Switch>
          <Route exact path={`${url}/`} component={withTokenVerified(Companies.List)} />
          <Route
            exact
            path={`${url}/companies/add`}
            component={withTokenVerified(Companies.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/edit`}
            component={withTokenVerified(Companies.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/edit_root`}
            component={withTokenVerified(Companies.Permisions)}
          />
          <Route
            exact
            path={`${url}/companies/:id`}
            component={withCompanySelected(Subcompanies.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/add`}
            component={withCompanySelected(Subcompanies.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:subcompanyId/edit`}
            component={withCompanySelected(Subcompanies.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/users`}
            component={withCompanySelected(Users.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/users/add`}
            component={withCompanySelected(Users.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/users/:userId/edit`}
            component={withCompanySelected(Users.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/roles`}
            component={withCompanySelected(Roles.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/roles/add`}
            component={withCompanySelected(Roles.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/roles/:roleId/edit`}
            component={withCompanySelected(Roles.Form)}
          />
          {/* Groups */}
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/groups`}
            component={withSubcompanySelected(Groups.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/groups/add`}
            component={withSubcompanySelected(Groups.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/groups/:groupId/edit`}
            component={withSubcompanySelected(Groups.Form)}
          />
          {/* Groups */}
          <Route
            exact
            path={`${url}/companies/:id/inpc`}
            component={withCompanySelected(Inpc.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/inpc/add`}
            component={withCompanySelected(Inpc.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/inpc/:iId/edit`}
            component={withCompanySelected(Inpc.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/exchange`}
            component={withCompanySelected(Exchange.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/exchange/add`}
            component={withCompanySelected(Exchange.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/exchange/:iId/edit`}
            component={withCompanySelected(Exchange.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/dashboard`}
            component={withSubcompanySelected(Dashboard)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets`}
            component={withSubcompanySelected(AssetsList)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets/add`}
            component={withSubcompanySelected(AssetsAdd)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets/:aid/edit/`}
            component={withSubcompanySelected(AssetsEdit)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets/:aid/edit/:isRequest`}
            component={withSubcompanySelected(AssetsEdit)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets/:aid/disable/`}
            component={withSubcompanySelected(AssetsDisable)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/assets/:aid/detail/`}
            component={withSubcompanySelected(FixedAssets.Detail)}
          />
          {/* Mantenimiento */}
          {/* <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/maintenance`}
            component={withSubcompanySelected(Maintenance.List)}
            />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/maintenance/add`}
            component={withSubcompanySelected(Maintenance.Add)}
            
            />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/maintenance/:eid/edit`}
            component={withSubcompanySelected(Maintenance.Edit)} */}
          />
          {/* Mantenimiento */}
          {/* Custom Fields */}
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/custom_fields_employees`}
            component={withSubcompanySelected(CustomFieldsEmployees.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/custom_fields_employees/add`}
            component={withSubcompanySelected(CustomFieldsEmployees.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/custom_fields_employees/:eid/edit`}
            component={withSubcompanySelected(CustomFieldsEmployees.Form)}
          />
          {/* Custom Fields */}
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/employees`}
            component={withSubcompanySelected(Employees.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/employees/add`}
            component={withSubcompanySelected(Employees.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/employees/:eid/edit`}
            component={withSubcompanySelected(Employees.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/reports/depreciation`}
            component={withSubcompanySelected(ReportsDepreciation)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/reports/disabled`}
            component={withSubcompanySelected(Reports.DisabledReport)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/reports/employees_assets`}
            component={withSubcompanySelected(Reports.EmployeesAssetsReport)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/reports/historics`}
            component={withSubcompanySelected(Reports.HistoricsReport)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/reports/ins_outs`}
            component={withSubcompanySelected(Reports.InsOutsReport)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/import`}
            component={withSubcompanySelected(Import.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/import/add`}
            component={withSubcompanySelected(Import.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/providers`}
            component={withSubcompanySelected(Providers.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/providers/add`}
            component={withSubcompanySelected(Providers.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/providers/:pid/edit`}
            component={withSubcompanySelected(Providers.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/accounts`}
            component={withSubcompanySelected(Accounts.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/accounts/add`}
            component={withSubcompanySelected(Accounts.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/accounts/:aid/edit`}
            component={withSubcompanySelected(Accounts.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_config`}
            component={withSubcompanySelected(NotificationsConfig.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_config/add`}
            component={withSubcompanySelected(NotificationsConfig.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_config/:aid/edit`}
            component={withSubcompanySelected(NotificationsConfig.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_historic`}
            component={withSubcompanySelected(NotificationsHistoric.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_historic/add`}
            component={withSubcompanySelected(NotificationsHistoric.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/notifications_historic/:aid/edit`}
            component={withSubcompanySelected(NotificationsHistoric.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/subaccounts`}
            component={withSubcompanySelected(Subaccounts.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/subaccounts/add`}
            component={withSubcompanySelected(Subaccounts.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/subaccounts/:aid/edit`}
            component={withSubcompanySelected(Subaccounts.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/depreciations`}
            component={withSubcompanySelected(Depreciations.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/depreciations/add`}
            component={withSubcompanySelected(Depreciations.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/depreciations/:did/edit`}
            component={withSubcompanySelected(Depreciations.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/cost_centers`}
            component={withSubcompanySelected(CostCenters.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/cost_centers/add`}
            component={withSubcompanySelected(CostCenters.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/cost_centers/:did/edit`}
            component={withSubcompanySelected(CostCenters.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/catalogs`}
            component={withSubcompanySelected(Catalogs.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/catalogs/:did/edit`}
            component={withSubcompanySelected(Catalogs.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/locations`}
            component={withSubcompanySelected(Locations.Tree)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/projects`}
            component={withSubcompanySelected(Projects.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/projects/add`}
            component={withSubcompanySelected(Projects.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/projects/:pid/edit`}
            component={withSubcompanySelected(Projects.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/asset_level`}
            component={withSubcompanySelected(AssetLevel.List)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/asset_level/add`}
            component={withSubcompanySelected(AssetLevel.Form)}
          />
          <Route
            exact
            path={`${url}/companies/:id/subcompanies/:sid/asset_level/:pid/edit`}
            component={withSubcompanySelected(AssetLevel.Form)}
          />
          <Route>
            <Redirect to={`${url}/`} />
          </Route>
        </Switch>
      </Secured.Layout>
    );
  };
}

export default SecuredRoutes;



// WEBPACK FOOTER //
// src/modules/secured/routes/SecuredRoutes.js